import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export default function DialogTitle() {
	const { translate } = useLocales();
	return (
		<Stack gap={2} sx={{ p: 3 }}>
			<Typography alignSelf='center' textAlign={"center"} variant='h6'>
				{translate("api_client.delete_redirect_title")}
			</Typography>
			<Typography alignSelf='center' textAlign={"center"} variant='subtitle2'>
				{translate("api_client.delete_redirect_description")}
			</Typography>
		</Stack>
	);
}
